/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetHierarchyQueryResponse, HierarchiesControllerGetHierarchyQueryParams, HierarchiesControllerGetHierarchy401, HierarchiesControllerGetHierarchy403 } from "../../models/hierarchiesController/HierarchiesControllerGetHierarchy";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetHierarchy } from "../../clients/hierarchiesService/hierarchiesControllerGetHierarchy";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetHierarchyQueryKey = (params: HierarchiesControllerGetHierarchyQueryParams = {}) => [{
  url: '/api/v1/hierarchies/me'
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetHierarchyQueryKey = ReturnType<typeof hierarchiesControllerGetHierarchyQueryKey>;
export function hierarchiesControllerGetHierarchyQueryOptions(params?: HierarchiesControllerGetHierarchyQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetHierarchyQueryKey(params);
  return queryOptions<HierarchiesControllerGetHierarchyQueryResponse, ResponseErrorConfig<HierarchiesControllerGetHierarchy401 | HierarchiesControllerGetHierarchy403>, HierarchiesControllerGetHierarchyQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetHierarchy(params, config);
    }
  });
}

/**
 * @description Retrieve complete hierarchy information with full JSON:API compliant structure. Supports lazy loading and pagination of children.
 * @summary Get user hierarchy
 * {@link /api/v1/hierarchies/me}
 */
export function useHierarchiesControllerGetHierarchy<TData = HierarchiesControllerGetHierarchyQueryResponse, TQueryData = HierarchiesControllerGetHierarchyQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetHierarchyQueryKey>(params?: HierarchiesControllerGetHierarchyQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetHierarchyQueryResponse, ResponseErrorConfig<HierarchiesControllerGetHierarchy401 | HierarchiesControllerGetHierarchy403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetHierarchyQueryKey(params);
  const query = useQuery({
    ...hierarchiesControllerGetHierarchyQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetHierarchy401 | HierarchiesControllerGetHierarchy403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}